<template>
    <el-container class="unilateral-api">
        <el-main>
            <el-header class="column-header">
                任务列表
                <el-button class="btn_style" @click="addApiEvent">添加任务</el-button>
            </el-header>
            <el-table style="width: 100%" :data="tableData">
                <el-table-column v-for="(item, index) in tableColName" :key="'api-'+index"
                :label="item.title"
                :width="item.width"
                :prop="item.key">
                    <template slot-scope="scope">
                        <span class="strage_status" v-if="item.key == 'status'" 
                        :style="{'background-color': ctaskColorStatus(scope.row[item.key])}">
                            {{apiStatue(scope.row[item.key])}}
                        </span>
                        <span class="strategy__name" v-else-if="item.key == 'strategy'" @click="strategyJump(scope.row['strategy_id'])">
                            {{scope.row[item.key]}}
                        </span>
                        <span v-else>
                            {{scope.row[item.key]}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-dropdown trigger="click">
                            <el-button class="table-btn">操作<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="apiStateChange('start', scope.row.id)">立即启动</el-dropdown-item>
                                <el-dropdown-item @click.native="apiStateChange('startDelay', scope.row.id)">延时启动</el-dropdown-item>
                                <el-dropdown-item @click.native="apiStateChange('stop', scope.row.id)">停止</el-dropdown-item>
                                <el-dropdown-item @click.native="apidelete(scope.row.id)">删除</el-dropdown-item>
                                <el-dropdown-item @click.native="apiEdit(scope.row.id, scope.row.strategy_id)">编辑</el-dropdown-item>
                                <el-dropdown-item @click.native="showDetail(scope.row.id, scope.row.strategy_id)">详情</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
                <el-table-column label="管理">
                    <template slot-scope="scope">
                        <el-popover
                            placement="bottom"
                            title="标题"
                            width="200"
                            trigger="click">
                            <el-form label-width="100px">
                                <!-- <el-form-item label="api ID">
                                    <el-input v-model="apiId"></el-input>
                                </el-form-item> -->
                                <el-form-item label="数值">
                                    <el-input v-model="apiNum" placeholder="范围 -100~100"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button class="btn_style" @click="apiHandle(scope.row.id)">确认</el-button>
                                </el-form-item>
                            </el-form>
                            <el-button class="table-btn" slot="reference">手动</el-button>
                        </el-popover>
                        <el-button class="table-btn" :flag="scope.row.id" @click="manualEvent(scope.row.bourse, scope.row.id)">手动(新)</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-main>

        <!-- 添加任务 -->
        <TaskEditDialog ref="taskEditDialog"></TaskEditDialog>

        <!-- 手动 -->
        <el-dialog title="手动" :visible.sync="manualFlag">
            <el-form label-width="100px">
                <el-form-item label="委托价格">
                    <el-input v-model="manualParam.price"></el-input>
                </el-form-item>
                <el-form-item label="委托量">
                    <el-input v-model="manualParam.amount" placeholder="期货时，单位为张，现货为颗"></el-input>
                </el-form-item>
                <el-form-item label="合约类型">
                    <el-select v-model="manualParam.type" placeholder="请选择合约类型" @change="tradeChangeEvent">
                        <el-option v-for="(trade, index) in tradeTypeObj" :key="'trade'+index" :label="trade" :value="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="交易类型">
                    <el-select v-model="manualParam.direction" placeholder="请选择交易类型">
                        <el-option v-for="(trade, index) in tradeDirection" :key="'trade'+index" :label="index" :value="trade"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="价格方式">
                    <el-select v-model="manualParam.way" placeholder="请选择交易方向">
                        <el-option label="市价" value="1"></el-option>
                        <el-option label="限价" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="币对">
                    <el-input class="match_input" v-model="manualParam.symbol" @input="matchValue" @blur="loseForce"
                    placeholder="请输入币对"></el-input>
                    <ul class="input_dropdown" style="display: none;">
                        <li v-for="(i, index) in currencyMatchList" :key="'match_'+index" 
                        @click="currencySelect(i)">{{i}}</li>
                    </ul>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="manualFlag = false">取消</el-button>
                <el-button type="primary" @click="submitManual">确定</el-button>
            </div>
        </el-dialog>
        <!-- <Footer></Footer> -->
    </el-container>
</template>

<script>
/* eslint-disable */
import Header from "@/components/header/Header.vue";
// import Footer from "@/components/Footer/New-footer.vue";
import { get, put, post } from "@/api/index";
import { mapState, mapActions } from "vuex";
import { socket_url_ln } from "@/api/config";
import BreadCrumb from "@/components/global/My-breadcrumb.vue";
import { getApiList, postUnilateralTask } from "@/api/api";
import TaskEditDialog from "@/components/unilateral/Unilateral-task-edit.vue";

export default {
    components: {
        Header,
        // Footer,
        BreadCrumb,
        TaskEditDialog
    },
    data: function () {
        return {
            tableColName: [
                { title: '用户', key: 'user' },
                { title: '杠杆率(%)', key: 'ratio' },
                { title: '策略比例(%)', key: 'strategy_ratio' },
                { title: '备注', key: 'names' },
                { title: '策略名', key: 'strategy' },
                { title: '状态', key: 'status' },
                { title: "最近交易时间", key: 'createtime' }
            ],
            tableData: [],
            addApiFlag: false,
            formParam: {
                'strategyId': '',
                "unit": "usd",
                "api_id": ''
            },

            apiId: '',
            apiNum: '',
            dialogType: 'add',

            apiVerifyStatus: '',
            apiVerifyColor: '',
            timer: '',
            manualFlag: false,
            manualParam: {
                
            },
            tradeType: ['SS', 'CS', 'CW', 'NW', 'CQ', 'NQ'],
            tradeDirection: '',
            thisBourse: '',
            currencys: {},
            currencyMatchList: [],
            pageChange: false,
        }
    },
    mounted() {
        if (this.token) {
            this.getApiList();
            this.createSocket();
        }
    },
    beforeDestroy() {

    },
    computed: {
        ...mapState([
            'token',
            'userLevel',
            'tradeTypeObj',
            'uniSocket'
        ])
    },
    methods: {

        // Get api list
        getApiList() {
            var url = this.$url_LN_local + '/get/task/list';
            var param = {'token': this.token};

            get(url, param, true).then(res => {
                if (res.code === 200) {
                    this.tableData = res.data;
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        apiStatue(state) {
            if (state == '1') return '自动';
            else if (state == '0') return '停止';
            else if (state == '2') return '手动';
            else if (state == '3') return '延时';
            else if (state == '4') return '止损';
        },

        // api status change
        apiStateChange(flag, id) {
            var url = this.$url_LN_local + '/put/task/state';
            var param = {
                'token': this.token,
                'apis': [id]
            };

            if (flag == 'start') {
                param['state'] = 1;
            } else if (flag == 'stop') {
                param['state'] = 0;
            } else if (flag == 'startDelay') {
                param['state'] = 3;
            }

            put(url, param).then(res => {
                if (res.code === 200) {
                    this.getApiList();
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        // 删除api
        apidelete(id) {

            this.$confirm('是否删除该API?', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var url = this.$url_LN_local + '/delete/task';
                var param = {
                    token: this.token,
                    apiId: id
                };

                post(url, JSON.stringify(param)).then(res => {
                    if (res.code == 200) {
                        this.$notify.info({
                            message: res.info,
                            title: '提示',
                            offset: 100
                        });
                        this.getApiList();
                    } else {
                        this.$notify.error({
                            message: res.info,
                            title: '提示',
                            offset: 100
                        });
                    }
                })
            }).catch(() => {

            })
        },

        // 手动处理api
        apiHandle(id) {
            var url = this.$url_LN_local + '/manual/follow';
            if (Number(this.apiNum) > 100 || Number(this.apiNum) < -100) {
                this.$notify.info({
                    message: "数值超出了范围",
                    title: "提示",
                    offset: 200
                });
                return;
            }

            var param = {
                'token': this.token,
                'apiId': id,
                'number': this.apiNum
            };

            post(url, JSON.stringify(param)).then(res => {
                if (res.code === 200) {
                    this.$notify.info({
                        message: res.info,
                        title: '提示',
                        offset: 200
                    })
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: '提示',
                        offset: 200
                    })
                }
            })
        },

        // api编辑
        apiEdit(id, s_id) {
            this.dialogType = 'edit';
            this.apiVerifyColor = '';
            this.apiVerifyStatus = '';
            this.$refs.taskEditDialog.initDialog(id, this.dialogType);
        },

        // 添加api 按钮
        addApiEvent() {
            this.addApiFlag = true;
            this.dialogType = "add";
            this.apiVerifyColor = '';
            this.apiVerifyStatus = '';
            this.$refs.taskEditDialog.initDialog('', this.dialogType);
        },

        // api 验证
        verifyApi() {
            var url = this.$url_LN_local + '/validation/task';
            var param = {
                "privateKey": this.formParam.privateKey,
                "publicKey": this.formParam.publicKey,
                "tokenStr": this.formParam.tokenStr,
                "bourse": this.formParam.bourse
            };
            this.apiVerifyStatus = "正在检验...";
            post(url, JSON.stringify(param)).then(res => {
                if (res.code == 200) {
                    this.apiVerifyStatus = res.info;
                    this.apiVerifyColor = "#409eff";
                } else {
                    this.apiVerifyStatus = res.info;
                    this.apiVerifyColor = "#e81414";
                }
            })
        },

        // 手动 新
        manualEvent(bourse, id) {
            this.manualFlag = true;
            this.manualParam = {};
            this.thisBourse = bourse;
            this.manualParam['apiId'] = id;
        },

        // 交易类型 切换事件
        tradeChangeEvent(e) {
            if (e == 'SS') {// 现货
                this.tradeDirection = {"买": 1, "卖": 2};
            } else {
                this.tradeDirection = {'开多': 1,"开空": 2, "平多": 3, "平空": 4};
            }

            this.getCurrencys(e);
        },

        // 手动（新）提交
        submitManual() {
            // console.log(this.manualParam, this.apiId);
            var url = this.$url_LN_local + '/manual/trading';
            var param = this.manualParam;
            param['token'] = this.token;

            post(url, param).then(res => {
                if (res.code === 200) {
                    this.manualFlag = false;
                    this.$notify.info({
                        message: '操作成功',
                        title: '提示',
                        offset: 100
                    })
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: "提示",
                        offset: 100
                    })
                }
            });

        },

        // 页面跳转
        strategyJump(id) {
            let strategy_static = this.$router.push({
                path: '/unilateral/statistic',
                query: {
                    key: id
                }
            });
        },

        // 获取币对
        getCurrencys(tps) {
            var url = this.$url_LN_local + '/get/currency/information';
            var param = {
                "bourse": this.thisBourse,
                "types": tps
            };

            get(url, param).then(res => {
                if (res.code == 200) {
                    this.currencys = res.data;
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: '提示',
                        offset: 100
                    })
                }
            });
        },

        // 币对匹配
        matchValue(e) {
            this.currencyMatchList = []
            for (var i=0;i<this.currencys.length; i++) {
                if (this.currencys[i].indexOf(e) !== -1) {
                    this.currencyMatchList.push(this.currencys[i])
                }
            }
            var width = $('.match_input').width();

            $('.input_dropdown').css({
                'display': '',
                "width": width+"px"
            });
        },

        // 币对 选择事件
        currencySelect(cur) {
            this.manualParam.symbol = cur;
            $('.input_dropdown').css('display', 'none');
        },

        // 失去焦点
        loseForce() {
            if (!this.manualParam.symbol) {
                $('.input_dropdown').css('display', 'none');
            }
        },

        // websocket 创建
        createSocket() {
            var url = this.$socket_url_ln + '/web/all/data?token='+this.token;
            if (!this.uniSocket.skt) {
                this.uniSocket.skt = new WebSocket(url);
                console.log("websocket connect successfully ", this.uniSocket.skt.readState);
            }

            this.webSocketInit();
        },

        // websocket 初始化
        webSocketInit() {
            this.uniSocket.skt.onopen = this.socketOpen;
            this.uniSocket.skt.onmessage = this.getMsg;
            this.uniSocket.skt.onclose = this.socketClose;
        },

        getMsg(res) {
            var data = JSON.parse(res.data);
            if (!data.hasOwnProperty('code')) {
                this.tableData = data.api;
            }
        },

        socketOpen() {

        },

        socketClose(e) {
            console.log("webSocket connect close ", e);
        },

        // 详情
        showDetail(taskId, sid) {
            this.pageChange = true;
            this.$router.push({
                path: '/main/index/api/detail',
                query: {
                    key: taskId
                }
            });
        },

        // 任务颜色状态
        ctaskColorStatus(flag) {
            let flags = String(flag);
            if (flags == '1') {
                return "#1aa094";
            } else if (flags == '2') {
                return '#1aa094';
            } else if (flags == '3') {
                return '#1aa094';
            } else if (flags == '4') {
                return '#ec3838';
            }
            return '#db5634';
        }
    }
}
</script>

<style lang="scss">
.el-popover {
    background-color: #fff;
    width: 400px !important;
    .el-form {
        width: 300px;
    }
}
.unilateral-api {
    // padding-top: 30px;
    background-color: #252425;
    color: #a8a7a9;

    .form_btn_style {
        background-color: #409eff;
        padding: 3px 10px;
        border-radius: 3px;
        color: #fff;
        cursor: pointer;
    }

    .form_verify_info {
        margin-left: 10px;
        font-size: 12px;
        color: #409eff;
    }

    .el-dialog__header {
        padding: 10px !important;
        background-color: #fff !important;
        border-bottom: 1px solid #daddde;
    }

    .el-form {
        .el-form-item__content {
            text-align: left;
        }

        .el-select {
            width: 100%;
        }
    }

    .btn_style {
        border-radius: 3px;
        padding: 5px 10px;
        box-sizing: border-box;
        display: inline-block; 
        background-color: #333333;
        border-color: #333333;
        margin: 0 5px;
    }

    .cell {
        text-align: center;
    }

    .strage_status {
        border-radius: 3px;
        color: #fff;
        padding: 3px 6px;
        box-sizing: border-box;
        display: inline-block;
        font-size: 12px;
    }

    .el-main {
        // padding: 15px 0;
        background-color: #252425;
        .el-header {
            background-color: #1e1e1e;
            text-align: left;
            padding: 5px 10px;
            vertical-align: middle;
            display: flex;
            align-items: center;
        }

        .el-table {
            background-color: #2a2d2e;
            padding-bottom: 80px;
            .strategy__name {
                cursor: pointer;
            }

            .table-btn {
                background-color: #333333;
                border-color: #333333;
                padding: 8px 14px;
            }

            .el-button {
                margin-right: 5px;
            }

            .el-table__header-wrapper {
                background-color: transparent !important;
            }
            th.is-leaf, td {
                background-color: #2a2d2e;
                border-bottom: 1px solid #3a393a;
            }

            th, tr {
                background-color: transparent;
            }

            tbody {
                tr:hover {
                    background-color: transparent;
                    td {
                        color: #999999;
                        background-color: transparent;
                    }
                }

            }
        }

        .el-table--border::after, .el-table--group::after, .el-table::before {
            content: '';
            position: absolute;
            background-color: transparent;
            z-index: 1;
        }
    }

    .input_dropdown{
        border: 1px solid #e0dfdf;
        max-height: 150px;
        overflow-y: scroll;
        position: fixed;
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
        box-sizing: border-box;
        li {
            padding: 0 10px;
            font-size: 12px;
            height: 24px;
            vertical-align: middle;
            line-height: 24px;
            background-color: #fff;
        }
        li:hover{
            background-color: #c1c1c1;
        }
    }
}
</style>

